export { SvgIcon } from './SvgIcon';

export type { IconSize } from './SvgIcon.styles';
